import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Page from "components/common/page/Page";
import WalletDatalist from "components/entities/app/person/wallet/WalletDatalist";
import { AppRoutes } from "config/router";
import { Roles } from "utilities/app-utilities";
import useAppContext from "utilities/hooks/useAppContext";

const WalletDatalistPage = () => {
    const context = useAppContext();

    const pageActions = [
        {
            icon: faPlus,
            link: AppRoutes.PERSON_WALLET_FORM,
            hide: !context.userHasRole(Roles.ADMIN),
            name: 'add',
            title: context.t('button.add')
        }
    ];

    return (
        <Page title={context.t('pages.wallets.list')} actions={pageActions} wFull>
            <WalletDatalist name="people-wallet-page-datalist" />
        </Page>
    );
};

export default WalletDatalistPage;
